import * as ActionTypes from '../ActionTypes';

const initialState = {
    error: null,
    pmsFeedbackLoading: false,
    feedbackData: [],
};

export const PmsFeedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.PMS_FEEDBACK_GET_REQUEST:
            return {
                ...state,
                pmsFeedbackLoading: true,
                feedbackData: [],
                error: null,
            };
        case ActionTypes.PMS_FEEDBACK_ADD_REQUEST:
        case ActionTypes.PMS_FEEDBACK_UPDATE_REQUEST:
        case ActionTypes.PMS_FEEDBACK_DELETE_REQUEST:
            return {
                ...state,
                pmsFeedbackLoading: true,
                error: null,
            };

        case ActionTypes.PMS_FEEDBACK_GET_SUCCESS:
        case ActionTypes.PMS_FEEDBACK_ADD_SUCCESS:
        case ActionTypes.PMS_FEEDBACK_UPDATE_SUCCESS:
        case ActionTypes.PMS_FEEDBACK_DELETE_SUCCESS:
            return {
                ...state,
                pmsFeedbackLoading: false,
                feedbackData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.PMS_FEEDBACK_GET_ERROR:
        case ActionTypes.PMS_FEEDBACK_ADD_ERROR:
        case ActionTypes.PMS_FEEDBACK_UPDATE_ERROR:
        case ActionTypes.PMS_FEEDBACK_DELETE_ERROR:
            return {
                ...state,
                pmsFeedbackLoading: false,
                error: true,
            };

        default:
            return state;
    }
};
